import { DraftState } from '@/types';

export const getSelectedSizes = (draft: DraftState) => draft.selectedSizes;
